import { render, staticRenderFns } from "./MinorConfig.vue?vue&type=template&id=2052383f&scoped=true&"
import script from "./MinorConfig.vue?vue&type=script&lang=js&"
export * from "./MinorConfig.vue?vue&type=script&lang=js&"
import style0 from "./MinorConfig.vue?vue&type=style&index=0&id=2052383f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052383f",
  null
  
)

export default component.exports